'use client';

import RequiredField from '../RequiredField';
import { namePattern, onInputNameHandler } from '../utils/nameFields';

import type { TextFieldProps } from '@haaretz/s-text-field';

export default function FirstNameField(props: TextFieldProps) {
  return (
    <RequiredField
      name={props.name || 'firstName'}
      textFieldType="firstName"
      data-testid="first-name-field"
      minLength={2}
      maxLength={40}
      pattern={namePattern}
      onInput={onInputNameHandler}
      {...props}
    />
  );
}
